// local
import * as SimpleModal from '../simpleModal';

const ACTION_KEY = 'MODAL_CONFIRM_EDIT_SEND';

export function openModal(data) {
    return SimpleModal.openModal(ACTION_KEY, data);
}

export function closeModal() {
    return SimpleModal.closeModal(ACTION_KEY);
}
